export const actions = {
    IS_LOADING: 'IS_LOADING',
};

export const setLoading = (isLoading: boolean) => ({
    type: actions.IS_LOADING,
    isLoading,
});
